import React from "react"

export const modalRef: any = React.createRef()